module.exports = __webpack_public_path__ + "static/media/Congratulations.b49788b7.svg";